import { connect } from 'react-redux';
import { baseDomain } from '../../../../../core/selectors/institution';
import {
  accessingCurrentSpaceAsStaff,
  isInstructorInSpace,
} from '../../../../../core/selectors/classroom';
import fetchAccessTokenAction from '../../../../../core/actions/accessToken/accessToken.action';
import {
  operations as assignmentOperations,
  selectors as assignmentSelectors,
} from '../../../../store/assignments';
import {
  currentUserId,
  needsToRefreshAccessToken,
} from '../../../../../core/selectors/user';
import { location } from '../../../../selectors/routing';
import AssignmentsResponsive from './AssignmentResponsive';

export const mapStateToProps = (state) => {
  const userId = currentUserId(state);
  const spaceId = assignmentSelectors.getSelectedSpaceId(state);

  const needsToRefreshAccessTokenProp = () => {
    return spaceId ? needsToRefreshAccessToken(state, spaceId) : false;
  };
  const isStaff = accessingCurrentSpaceAsStaff(state);

  const [assignmentId] = location(state).pathname
    ? location(state).pathname.split('/').slice(-1)
    : [''];

  const parentAssignmentSubmissions =
    assignmentSelectors.getAssignmentSubmissions(state, assignmentId);
  const hasFetchedSubmissions = assignmentSelectors.hasFetchedSubmissions(
    state,
    assignmentId
  );

  return {
    user: state.user.user,
    selectedSpace: spaceId ? state.data.classRooms[spaceId] : undefined,
    isFetching:
      assignmentSelectors.isFetchingAssignments(state) ||
      state.accessTokens.isFetching,
    hasFetchedAssignments: assignmentSelectors.hasFetchedAssignments(state),
    hasFetchAssignmentsErrored: assignmentSelectors.isErrored(state),
    accessTokens: state.accessTokens,
    baseDomain: baseDomain(state),
    isEducator: spaceId ? isInstructorInSpace(state)(userId, spaceId) : false,
    needsToRefreshAccessTokenProp,
    isStaff,
    parentAssignmentSubmissions,
    hasFetchedSubmissions,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  fetchAssignments: dispatch(assignmentOperations.fetchAssignments),
  fetchAccessToken: fetchAccessTokenAction(dispatch),
  fetchSubmissions: (params) =>
    dispatch(assignmentOperations.fetchSubmissions(params)),
});

const AssignmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignmentsResponsive);

export default AssignmentsContainer;
